import { render, staticRenderFns } from "./PersonCard.vue?vue&type=template&id=35125f2b&scoped=true&"
import script from "./PersonCard.vue?vue&type=script&lang=js&"
export * from "./PersonCard.vue?vue&type=script&lang=js&"
import style0 from "./PersonCard.vue?vue&type=style&index=0&id=35125f2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35125f2b",
  null
  
)

export default component.exports